import { combineReducers } from 'redux';

import ads from './ads/reducer';
import bankId from './bank-id/reducer';
import categories from './categories/reducer';
import discover from 'tradera-state/discover/reducer';
import environment from './environment/reducer';
import initData from './init-data/reducer';
import items from './items/reducer';
import internationalShipping from './international-shipping/reducer';
import language from './language/reducer';
import member from './member/reducer';
import multiCurrency from './multi-currency/reducer';
import page from './page/reducer';
import personalisation from './personalisation/reducer';
import pushNotifications from './push-notifications/push-notifications-slice';
import shippingRegion from './shipping-region/reducer';
import ui from './ui/reducer';
import views from './views/reducer';
import { connectRouter } from 'connected-react-router';

export default history =>
    combineReducers({
        ads,
        bankId,
        categories,
        discover,
        environment,
        initData,
        internationalShipping,
        items,
        language,
        member,
        multiCurrency,
        page,
        personalisation,
        pushNotifications,
        shippingRegion,
        ui,
        views,
        router: connectRouter(history)
    });
